
<v-card
    :ripple = "false"
    :height = "item.size-10"
    class   = "pa-0"
    flat
    rounded
>
    <v-card-text
        class="h-100 lm-border pa-2 "
    >
        <div
            v-if  = "item.type.name === 'Manuell'"
            class = "import-upload mb-1"
        >
            <div class="v-flex w-100" >
                <div class="import-sender">
                    {{ $t("inb.overview.imports.upload") }}
                </div>
                <v-spacer />
                <div class="import-date">
                    {{ format (item.received) }}
                </div>
            </div>
            <div v-if="item.customer" class="import-customer">
                {{ item.customer.name }}
            </div>
        </div>

        <div
            class = "import-attachment w-100 pa-2 pt-1 pl-0 pr-0 pb-0 mb-1"
            v-if  = "item.type.name === 'Email'"
        >
            <v-row dense>
                <div style="width: calc(100% - 0px)">
                    <div class="v-flex">

                        <div class="import-sender">
                            {{ item.sender }}
                        </div>
                        <v-spacer />
                        <div class="import-date">
                            {{ format (item.received) }}
                        </div>
                    </div>
                    <div class="v-flex import-subject primary--text" >
                        {{ item.subject }}
                    </div>
                    <div v-if="item.customer" class="import-customer">
                        {{ item.customer.name }}
                    </div>
                </div>
            </v-row>
        </div>

        <v-expansion-panels
            v-model = "expandAttachments"
            class   = "mb-1 ml-0"
            accordion
            flat
        >
            <v-expansion-panel
                class = "pa-0"
                :key  = "1"
            >
                <v-expansion-panel-header
                    :ripple     = "false"
                    class       = "pa-0"
                    expand-icon = ""
                >
                    <div style="display: block">
                        <c-import-attachment
                            :value    = "item.messages[0]"
                            :is-selected = "isSelected(item.messages[0])"
                            @selected    = "onAttachment"
                        />
                    </div>

                    <div class="import-fab" v-if="item.messages.length > 1 && expandAttachments !== 0">
                        <v-fab-transition>
                            <v-btn
                                color="lightgray"
                                x-small
                                top
                                right
                            >
                                <v-icon>mdi-chevron-down</v-icon>
                            </v-btn>
                        </v-fab-transition>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                    class = "pa-0 ma-0 mb-0"
                    style = "border-top-left-radius: 0!important; border-top-right-radius: 0!important;"
                    eager
                >
                    <c-import-attachment
                        v-for        = "attachment in extendedAttachements"
                        :value  = "attachment"
                        :key         = "attachment.id"
                        :is-selected = "isSelected(attachment)"
                        @selected    = "onAttachment"
                    />

                    <div class="import-fab-expanded" style="bottom: 0" v-if="item.messages.length > 1 && expandAttachments === 0">
                        <v-fab-transition>
                            <v-btn
                                color="lightgray"
                                x-small
                                top
                                right
                                @click="expandAttachments=undefined"
                            >
                                <v-icon>mdi-chevron-up</v-icon>
                            </v-btn>
                        </v-fab-transition>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-card-text>
 </v-card>
